// extracted by mini-css-extract-plugin
module.exports = {"message":"_2ROPC","selectWrapper":"_18sX2"};